import { render, staticRenderFns } from "./RenameDocumentDialog.vue?vue&type=template&id=b1359f28&scoped=true"
import script from "./RenameDocumentDialog.vue?vue&type=script&lang=js"
export * from "./RenameDocumentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1359f28",
  null
  
)

export default component.exports